import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Keeper',
  form,
  marshal 
}

export default provider
